export default __webpack_public_path__ + "static/media/icon-zoom-in.de772c76.svg";